import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    listItemAriaLabel: ({ name }: {
        name: string;
    }) => string;
    quickSearchAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessible label for individual search result item */
            listItemAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ name }: {
                        name: string;
                    }): string => __intl__.intl().formatMessage({ id: "QuickSearchDialogContent.listItemAriaLabel?c=112aa0f7ix6vk", defaultMessage: "Search result: {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the entire quick search component */
            quickSearchAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchDialogContent.quickSearchAriaLabel?c=3amyyg9z48dnb", defaultMessage: "Quick Search" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
